import { useAuthenticatedUser } from './useAuthenticatedUser';
import { useClient } from './useClient';

export function useSessionStorage() {
  const isBrowser: boolean = ((): boolean => typeof window !== 'undefined')();

  const { clientId } = useClient();
  const { authenticatedUser } = useAuthenticatedUser({ bypassCache: false });

  const getSessionItem = (key: string): string => {
    return (
      (isBrowser &&
        sessionStorage.getItem(`IdentityService.${clientId}.${key}`)) ||
      ''
    );
  };

  const setSessionItem = (key: string, value: string): void => {
    if (isBrowser) {
      sessionStorage.setItem(`IdentityService.${clientId}.${key}`, value);
    }
  };

  const removeSessionItem = (key: string): void => {
    if (isBrowser) {
      sessionStorage.removeItem(`IdentityService.${clientId}.${key}`);
    }
  };

  const getAuthItem = (key: string): string => {
    return (
      (isBrowser &&
        authenticatedUser &&
        sessionStorage.getItem(
          `IdentityService.${clientId}.${authenticatedUser?.username}.${key}`
        )) ||
      ''
    );
  };

  const setAuthItem = (key: string, value: string): void => {
    if (isBrowser && authenticatedUser) {
      sessionStorage.setItem(
        `IdentityService.${clientId}.${authenticatedUser?.username}.${key}`,
        value
      );
    }
  };

  const removeAuthItem = (key: string): void => {
    if (isBrowser && authenticatedUser) {
      sessionStorage.removeItem(
        `IdentityService.${clientId}.${authenticatedUser?.username}.${key}`
      );
    }
  };

  return {
    getSessionItem,
    setSessionItem,
    removeSessionItem,
    getAuthItem,
    setAuthItem,
    removeAuthItem,
  };
}
